import { AppDescription } from '@/components/atoms/AppDescription/AppDescription'
import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { Button, Flex, Modal } from 'antd'
import React from 'react'

type Props = {
  onClose: () => void;
  open: boolean;
}

export function AuthLedgerAppNotChosen({ onClose, open }: Props) {
  return (
    <Modal
      rootClassName="errorLedgerModal"
      onCancel={onClose}
      open={open}
      footer={null}
      title={null}
      transitionName={null}
      maskTransitionName={null}
    >
      <Flex justify="center" align="center" gap={30} vertical>
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5535_27825)">
            <circle cx="28" cy="28" r="28" fill="black" />
            <g clipPath="url(#clip1_5535_27825)">
              <path
                d="M41.8558 35.4479L37.2336 40.3307C37.1331 40.4368 37.0115 40.5214 36.8764 40.5792C36.7413 40.637 36.5956 40.6667 36.4483 40.6667H14.5366C14.4321 40.6667 14.3298 40.6366 14.2424 40.5801C14.1549 40.5236 14.0861 40.4432 14.0445 40.3488C14.0028 40.2543 13.99 40.15 14.0078 40.0485C14.0255 39.947 14.0729 39.8528 14.1443 39.7775L18.77 34.8947C18.8702 34.7889 18.9914 34.7045 19.1261 34.6467C19.2607 34.5889 19.406 34.559 19.5529 34.5587H41.4634C41.5679 34.5587 41.6702 34.5888 41.7577 34.6453C41.845 34.7018 41.9138 34.7822 41.9556 34.8766C41.9972 34.9711 42.01 35.0754 41.9922 35.1769C41.9745 35.2784 41.9271 35.3726 41.8558 35.4479ZM37.2336 25.6153C37.1331 25.5092 37.0115 25.4247 36.8764 25.3669C36.7413 25.3091 36.5956 25.2793 36.4483 25.2794H14.5366C14.4321 25.2794 14.3298 25.3095 14.2424 25.3659C14.1549 25.4224 14.0861 25.5028 14.0445 25.5972C14.0028 25.6917 13.99 25.7961 14.0078 25.8976C14.0255 25.9991 14.0729 26.0932 14.1443 26.1686L18.77 31.0514C18.8702 31.1572 18.9914 31.2415 19.1261 31.2993C19.2607 31.3571 19.406 31.3871 19.5529 31.3873H41.4634C41.5679 31.3873 41.6702 31.3572 41.7577 31.3007C41.845 31.2443 41.9138 31.1639 41.9556 31.0694C41.9972 30.975 42.01 30.8706 41.9922 30.7691C41.9745 30.6676 41.9271 30.5734 41.8558 30.4981L37.2336 25.6153ZM14.5366 22.1079H36.4483C36.5956 22.108 36.7413 22.0782 36.8764 22.0204C37.0115 21.9626 37.1331 21.8781 37.2336 21.772L41.8558 16.8892C41.9271 16.8139 41.9745 16.7197 41.9922 16.6182C42.01 16.5167 41.9972 16.4123 41.9556 16.3179C41.9138 16.2234 41.845 16.143 41.7577 16.0866C41.6702 16.0301 41.5679 16 41.4634 16H19.5529C19.406 16.0002 19.2607 16.0302 19.1261 16.088C18.9914 16.1458 18.8702 16.2302 18.77 16.3359L14.1455 21.2188C14.0742 21.294 14.0268 21.3881 14.009 21.4894C13.9912 21.5908 14.0039 21.6951 14.0454 21.7895C14.087 21.8839 14.1555 21.9643 14.2428 22.0209C14.33 22.0774 14.4322 22.1077 14.5366 22.1079Z"
                fill="white"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_5535_27825">
              <rect width="56" height="56" fill="white" />
            </clipPath>
            <clipPath id="clip1_5535_27825">
              <rect width="28" height="24.6667" fill="white" transform="translate(14 16)" />
            </clipPath>
          </defs>
        </svg>
        <Flex vertical gap={15}>
          <AppTitle centered text="Select Solana" />
          <AppDescription
            centered
            description={(
              <>
                Select the Solana app on your Ledger
                <br />
                device to connect to GoDefi
              </>
            )}
          />
        </Flex>
        <Button onClick={onClose} className="mobilePrimaryButton" block type="primary">Got it</Button>
      </Flex>
    </Modal>
  )
}
